/**
 * Utilitário para Toast Notifications
 * Substitui alerts por notificações elegantes
 */

import { toast } from 'react-toastify';

export const showSuccess = (message) => {
  toast.success(message, {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    theme: "light",
  });
};

export const showError = (message) => {
  toast.error(message, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    theme: "light",
  });
};

export const showWarning = (message) => {
  toast.warning(message, {
    position: "top-right",
    autoClose: 4000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    theme: "light",
  });
};

export const showInfo = (message) => {
  toast.info(message, {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    theme: "light",
  });
};

export const showPromise = (promise, messages) => {
  return toast.promise(
    promise,
    {
      pending: messages.pending || 'Processando...',
      success: messages.success || 'Sucesso!',
      error: messages.error || 'Erro ao processar',
    },
    {
      position: "top-right",
      theme: "light",
    }
  );
};

export const showReanalisarConfirm = (onConfirm, onCancel) => {
  const CustomToast = ({ closeToast }) => (
    <div>
      <div style={{ marginBottom: '12px', fontWeight: 'bold' }}>
        ✨ Causa raiz atualizada!
      </div>
      <div style={{ marginBottom: '12px', fontSize: '14px' }}>
        Deseja que a IA reavalie os 5 Porquês e o Plano de Ação?
      </div>
      <div style={{ fontSize: '12px', color: '#666', marginBottom: '12px' }}>
        A IA vai considerar:
        <ul style={{ margin: '8px 0', paddingLeft: '20px' }}>
          <li>Nova causa raiz</li>
          <li>Descrição original da NC</li>
          <li>Evidências anexadas</li>
        </ul>
      </div>
      <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
        <button
          onClick={() => {
            onCancel();
            closeToast();
          }}
          style={{
            padding: '6px 12px',
            background: '#6c757d',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
          }}
        >
          Não
        </button>
        <button
          onClick={() => {
            onConfirm();
            closeToast();
          }}
          style={{
            padding: '6px 12px',
            background: '#667eea',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
          }}
        >
          Sim, Reanalisar
        </button>
      </div>
    </div>
  );

  toast(<CustomToast />, {
    position: "top-center",
    autoClose: false,
    closeOnClick: false,
    draggable: false,
    closeButton: false,
    style: { width: '400px' },
  });
};


/**
 * TD #48 follow-up (Sessão 24): toast contextual quando usuário edita
 * campo de contexto da NC. Aparece imediato no save (sem precisar rolar
 * pra ver o banner permanente no topo). Banner permanente continua como
 * fallback caso usuário feche o toast.
 *
 * Pattern espelha showReanalisarConfirm — autoClose=false, sem closeOnClick,
 * dois botões inline (Mais tarde / Recalcular agora).
 */
export const showRecalcularContextoToast = (onConfirm, onCancel) => {
  const CustomToast = ({ closeToast }) => (
    <div>
      <div style={{ marginBottom: '12px', fontWeight: 'bold' }}>
        🔄 Contexto da NC editado
      </div>
      <div style={{ marginBottom: '12px', fontSize: '14px' }}>
        A IA pode regerar a análise considerando o contexto atualizado.
      </div>
      <div style={{ fontSize: '12px', color: '#666', marginBottom: '12px' }}>
        Re-deriva toda a análise (6M, porquês, causa) a partir do contexto atual.
        O que você editou à mão é preservado e sinalizado.
      </div>
      <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
        <button
          onClick={() => {
            if (typeof onCancel === 'function') onCancel();
            closeToast();
          }}
          style={{
            padding: '6px 12px',
            background: '#6c757d',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
          }}
        >
          Mais tarde
        </button>
        <button
          onClick={() => {
            if (typeof onConfirm === 'function') onConfirm();
            closeToast();
          }}
          style={{
            padding: '6px 12px',
            background: '#d97706',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontWeight: 600,
          }}
        >
          🔄 Recalcular agora
        </button>
      </div>
    </div>
  );

  toast(<CustomToast />, {
    position: "top-right",
    autoClose: false,
    closeOnClick: false,
    draggable: false,
    closeButton: true,
    style: { width: '380px' },
  });
};
